// @ts-nocheck
/**
 * useInstance V2 - React Hook for Instance Operations
 *
 * CREATED: Issue #473 - V2 Repository Pattern
 * Instance primitive (Position #11/25) - EXECUTE phase
 */

import { useMemo } from 'react';
import { useApolloClient } from '@apollo/client/react';
import { type ApolloClient } from '@apollo/client';
import { createInstanceRepositoryV2 } from '../data/repositories/primitives';
import { useCurrentTenant } from './useCurrentTenant';

export function useInstance() {
  const client = useApolloClient() as ApolloClient;
  const { tenantId } = useCurrentTenant();
  const repository = useMemo(() => createInstanceRepositoryV2(client), [client]);
  return { repository, tenantId };
}

